import { render, staticRenderFns } from "./Exel.vue?vue&type=template&id=77c84fc2&scoped=true&"
import script from "./Exel.vue?vue&type=script&lang=js&"
export * from "./Exel.vue?vue&type=script&lang=js&"
import style0 from "./Exel.vue?vue&type=style&index=0&id=77c84fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c84fc2",
  null
  
)

export default component.exports